
import { FormControl, FormControlLabel, FormLabel, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CustomCheckbox from "../../CustomComponents/CustomCheckbox/CustomCheckbox";
import styles from '../../../styles/modules/RegistrationSetup.module.css';
import CustomPlaceAutocomplete from '../../CustomComponents/CustomPlaceAutocomplete.jsx';
export const inputTypes = {
    text: 'text',
    address: 'address',
    number: 'number',
    mobile: 'mobile',
    email: 'email',
    date: 'date',
    checkbox: 'checkbox',
    dropdown: 'dropdown',
    radio: 'radio',
    file: 'file'
};
export const inputTypeList = [
    'text','address', 'number', 'mobile','email', 'date', 'radio', 'checkbox', 'dropdown'
]

export const fieldSections = [
    {
        id: 'player_info',
        value: 'Player Info'
    },
    {
        id: 'additional_player_info',
        value: 'Additional Player Info'
    },
]

export const getFieldsByType = (fieldDetails) => {
    
    switch (fieldDetails.type) {
        case inputTypes.text:
            return (<TextField size="small" required={fieldDetails?.isRequired} className={styles['form_text_field_theme']} fullWidth type={fieldDetails.type} label={fieldDetails.name} />);
        case inputTypes.email:
            return (<TextField size="small" required={fieldDetails?.isRequired} className={styles['form_text_field_theme']} fullWidth type={fieldDetails.type} label={fieldDetails.name} />);
        case inputTypes.number:
            return (<TextField size="small" required={fieldDetails?.isRequired} className={styles['form_text_field_theme']} fullWidth type={fieldDetails.type} label={fieldDetails.name} />);
        case inputTypes.radio:
            return (
                <FormControl fullWidth>
                    <FormLabel required={fieldDetails?.isRequired} sx={{
                        '&.Mui-focused': {
                            color: 'var(--hoverColorBold)', // checked color
                        }
                    }} id="demo-radio-buttons-group-label">{fieldDetails?.name}</FormLabel>
                    <RadioGroup
                        row
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="female"
                        name="radio-buttons-group"
                    >
                        {JSON.parse(fieldDetails?.metadata)?.options?.map((op, index) =>
                            <FormControlLabel value={op?.toLowerCase()} key={index} control={<Radio sx={{
                                '&.Mui-checked': {
                                    color: 'var(--hoverColorBold)', // checked color
                                },
                                '&.Mui-checked ~ .MuiFormControlLabel-label': {
                                    color: 'var(--hoverColorBold)',
                                },
                            }} />} label={op} />)}
                    </RadioGroup>
                </FormControl>
            );
        case inputTypes.dropdown:
            return (
                <FormControl fullWidth data-testid="game-dropdown" className={styles['form_dropdown_input_theme']}>
                    <InputLabel sx={{
                        top: '-8px', '&.Mui-focused': {
                            top: '0px',
                        },
                        '&.MuiInputLabel-shrink': {
                            top: '0px',
                        },
                        transition: 'top 0.2s ease'
                    }} required={fieldDetails?.isRequired} id="demo-simple-select-autowidth-label">{fieldDetails?.name}</InputLabel>
                    <Select
                        size="small"
                        labelId="demo-simple-select-autowidth-label"
                        id="demo-simple-select-autowidth"
                        fullWidth
                        label={fieldDetails?.name}
                    >
                        {JSON.parse(fieldDetails?.metadata)?.options?.map((op, index) =>
                            <MenuItem key={index} value={op?.replaceAll(" ", "_")?.toLowerCase()}>{op}</MenuItem>
                        )}

                    </Select>
                </FormControl>
            );
        case inputTypes.date:
            return (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        className={styles['form_date_picker_theme']}
                        label={fieldDetails?.name + " *"}
                        slotProps={{
                            textField: {
                                size: 'small', 
                            },
                          }}
                        sx={{ width: "100%" }}
                    />
                </LocalizationProvider>
            )
        case inputTypes.checkbox:
            return <CustomCheckbox label={fieldDetails?.name} />
        case inputTypes.address:
            return <CustomPlaceAutocomplete label={fieldDetails.name} variant="outlined" inputSize="small" isRequired={fieldDetails?.isRequired} />
        default:
            return null;
    }
}
